import React from 'react';
import { Avatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi, faTv, faPhone } from '@fortawesome/pro-solid-svg-icons';

import { AuthContext } from '../../contexts/AuthContext';
import { parseStringOr } from '../../components/App/AppxUtils';

import imagesNet from "../../images/net.png";
import imagesVoice from "../../images/voice.png";
import imagesTv from "../../images/tv.png";


export default class PlanIcon extends React.Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.type = parseStringOr(props.type, "");

        if (this.type === "") {
            throw new Error("Type is required!");
        }

        this.state = {
            loading: true
        }
    }

    async componentDidMount() {
        this.org = await this.context.org;

        this.setState({loading: false});
    }


    render() {
        if (this.state.loading) {
            return null;
        }

        let icon = null;

        if (this.org === "fa") {
            if (this.type === "net") {
                icon = (<img src={imagesNet} alt="Net Icon" />);
            }
            else if (this.type === "voice") {
                icon = (<img src={imagesVoice} alt="Voice Icon" />);
            }
            else {
                icon = (<img src={imagesTv} alt="TV Icon" />);
            }
        }
        else {
            if (this.type === "net") {
                icon = (
                    <Avatar
                        shape="circle"
                        size={32}
                        style={{backgroundColor: '#eb303f'}}
                        icon={<FontAwesomeIcon icon={faWifi} />} />
                );
            }
            else if (this.type === "voice") {
                icon = (
                    <Avatar
                        shape="circle"
                        size={32}
                        style={{
                            marginLeft: 5,
                            backgroundColor: '#8b506b'
                        }}
                        icon={<FontAwesomeIcon icon={faPhone} />} />
                );
            }
            else {
                icon = (
                    <Avatar
                        shape="circle"
                        size={32}
                        style={{
                            marginLeft: 5,
                            backgroundColor: '#2a7275'
                        }}
                        icon={<FontAwesomeIcon icon={faTv} />} />
                );
            }
        }

        return icon;
    }
}
